"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    campusState: {
        en: "Campus {place}",
        es: "Plantel {place}",
    },
    transitState: {
        en: "Transit to {place}",
        es: "Tránsito a {place}",
    },
    deliveryFinished: {
        en: "Delivery Finished",
        es: "Entrega Finalizada",
    },
    deliveryFinishedManually: {
        en: "Manually Completed Delivery",
        es: "Entrega Finalizada Manualmente",
    },
    deliveryTime: {
        en: "Delivery Time",
        es: "Tiempo de entrega",
    },
    transportNumber: {
        en: "Transport Number",
        es: "Número de transporte",
    },
    saveDeliveryCycleSuccess: {
        en: "Delivery Cycle was saved correctly",
        es: "El ciclo de entrega se guardó correctamente",
    },
    addDeliveryCycle: {
        en: "Add Delivery Cycle",
        es: "Agregar Ciclo de Entrega",
    },
    routeToCover: {
        en: "Route to Cover",
        es: "Ruta a Cubrir",
    },
    state: {
        en: "State",
        es: "Estado",
    },
    actualDeliveryTime: {
        en: "Actual Delivery Time",
        es: "Tiempo de Entrega Real",
    },
    departureTimeOrigin: {
        en: "Departure Time from Origin",
        es: "Hora Salida del Origen",
    },
    timeLimitClient: {
        en: "Time Limit at Client Campus",
        es: "Tiempo Límite en Plantel Cliente",
    },
    timeElapsed: {
        en: "Time Elapsed",
        es: "Tiempo Transcurrido",
    },
    customerDepartureTime: {
        en: "Customer Departure Time",
        es: "Hora de Salida del Plantel Cliente",
    },
    estimatedTimeArrival: {
        en: "Estimated Time of Arrival",
        es: "Tiempo Estimado de Llegada",
    },
    elapseTimeFormat: {
        en: "Time Format: Days, Hour:Minutes:Seconds",
        es: "Formato de Tiempo: Dias, Hora:Minutos:Segundos",
    },
    going: {
        en: "Going",
        es: "Ida",
    },
    return: {
        en: "Return",
        es: "Regreso",
    },
    closeManualCycle: {
        en: "Close Manual Cycle",
        es: "Cerrar Ciclo Manual",
    },
    summaryDelivery: {
        en: "Summary Delivery",
        es: "Resumen de Entrega",
    },
    saveObservationSuccess: {
        en: "The observation was saved successfully.",
        es: "La observación se guardo exitosamente.",
    },
    saveObservation: {
        en: "Save Observations",
        es: "Guardar Observaciones",
    },
    arriveClientTime: {
        en: "Customer Arrival Time",
        es: "Hora de Llegada al Cliente",
    },
    arriveTimeOrigin: {
        en: "Arrival time at Origin",
        es: "Hora de Llegada al Origen",
    },
    manageRouteOutput: {
        en: "Manage Route Exit",
        es: "Gestionar Salida de Ruta",
    },
    cancelDeliverySuccess: {
        en: "The delivery was successfully canceled",
        es: "La entrega se canceló exitosamente",
    },
    manageRouteSuccess: {
        en: "The route output was successfully managed",
        es: "Se gestionó exitosamente la salida de ruta",
    },
    timeGone: {
        en: "Time Go",
        es: "Tiempo Ida",
    },
    actualTimeGone: {
        en: "Time Go Real",
        es: "Tiempo Ida Real",
    },
    timeSpentClient: {
        en: "Time Status at Client Campus",
        es: "Tiempo Estado en Plantel Cliente",
    },
    returnTime: {
        en: "Return Time",
        es: "Tiempo de Retorno",
    },
    actualReturnTime: {
        en: "Return Time Real",
        es: "Tiempo de Retorno Real",
    },
    cycleTime: {
        en: "Cycle Time",
        es: "Duración del Ciclo",
    },
    actualCycleTime: {
        en: "Cycle Time Real",
        es: "Duración del Ciclo Real",
    },
    routeDepartureManagement: {
        en: "Route Departure Management",
        es: "Gestión de Salida de Ruta",
    },
    orderNumber: {
        en: "Orden Number",
        es: "Número de Pedido",
    },
    transporter: {
        en: "Transporter",
        es: "Transportista",
    },
    routeWithoutTrace: {
        en: "Allow trace without route",
        es: "Permitir rastro sin ruta",
    },
    delayedUnits: {
        en: "Delayed Units",
        es: "Unidades Atrasadas",
    },
    orderFormatError: {
        en: "The order number only can contain numbers.",
        es: "El número de orden solo puede contener números.",
    },
    deviceHasDeliveryAlready: {
        en: "The device has delivery cycle already assign.",
        es: "El dispositivo ya tiene un ciclo de entrega asignado.",
    },
    emptyCycleEventList: {
        en: "No alerts have been generated during the delivery cycle.",
        es: "No se han generado alertas durante el ciclo de entrega.",
    },
};
exports.default = translations;
